import React, { useEffect, useState, useRef } from 'react';
import { useRouteStore } from '../../Route/useRouteStore';
import { useModalPage }  from '../CourierModal'; // <- добавить
import api from '../../../../services/api';
import styles from "../styles/IssueCheck.module.css";

export default function IssueCheckPage() {
  const receiptId      = useRouteStore(s => s.selectedReceiptId);
  const updateReceipt  = useRouteStore(s => s.updateReceipt);

  const [receipt, setReceipt]     = useState(null);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState('');
  const { goTo }      = useModalPage();

  // form state
  const [paymentMethod, setPaymentMethod]     = useState('cash');
  const [email, setEmail]                     = useState('');
  const [phone, setPhone]                     = useState('');
  const [availableEmails, setAvailableEmails] = useState([]);
  const [availablePhones, setAvailablePhones] = useState([]);
  const [isManualEmail, setIsManualEmail]     = useState(false);
  const [isManualPhone, setIsManualPhone]     = useState(false);
  const [selectedContact, setSelectedContact] = useState({ type: null, value: '' });
  const [isProcessing, setIsProcessing]       = useState(false);

  const emailInputRef = useRef();
  const phoneInputRef = useRef();
  const didFetch = useRef(false);
  useEffect(() => {
    if (!receiptId || didFetch.current) return;
    didFetch.current = true;
    setLoading(true);

    const fetchData = async () => {
      try {
        // теперь возвращается сразу data
        const receiptData   = await api.get(`/receipts/${receiptId}`);
        setReceipt(receiptData);
      } catch {
        setError('Не удалось загрузить квитанцию');
        setLoading(false);
        return;
      }finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [receiptId]);


  // Обработчик для выбора контакта из списка
  const handleSelectContact = (type, value) => {
    setSelectedContact({ type, value });
    if (type === "email") {
      setEmail(value);
      setPhone(""); // сбросить телефон
    } else if (type === "phone") {
      setPhone(value);
      setEmail(""); // сбросить email
    }
  };

    const handleManualEmail = () => {
    setIsManualEmail(true);
    setIsManualPhone(false); // Отключаем режим ввода телефона, если он был включен
    setSelectedContact({ type: "", value: "" }); // Сбрасываем выбранный контакт
    setEmail(""); // Сбрасываем значение, чтобы поле ввода было пустым
    setTimeout(() => {
      emailInputRef.current && emailInputRef.current.focus();
    }, 100);
  };

    // Переключение на ручной ввод для телефона
    const handleManualPhone = () => {
      setIsManualPhone(true);
      setIsManualEmail(false); // Отключаем режим ввода email, если он был включен
      setSelectedContact({ type: "", value: "" });
      setPhone(""); // Сбрасываем значение, чтобы поле ввода было пустым
      setTimeout(() => {
        phoneInputRef.current && phoneInputRef.current.focus();
      }, 100);
    };
  
    // Отмена ручного ввода для email
    const cancelManualEmail = () => {
      setIsManualEmail(false);
    };
  
    // Отмена ручного ввода для телефона
    const cancelManualPhone = () => {
      setIsManualPhone(false);
    };

      // После загрузки квитанции заполняем поля по умолчанию
       // После загрузки квитанции: подставляем первый email/phone из receipt
    useEffect(() => {
      if (!receipt) return;
      if (!email) {
        setEmail(receipt.email || "");
      }
      if (!phone && receipt.delivery_comment) {
        const phoneRegex = /((?:8|\+7)[\s-]*(?:\(?\d{3}\)?)[\s-]*\d{3}[\s-]*\d{2}[\s-]*\d{2})/;
        const m = receipt.delivery_comment.match(phoneRegex);
        setPhone(m ? m[0].replace(/[\s\-()]/g, "") : "");
      }
    }, [receipt, email, phone]);
      
  // Собираем все email/телефоны из receipt и предвыбираем первый
  useEffect(() => {
    if (!receipt) return;
    // 1) email
    let emails = [];
    if (receipt.email) emails.push(receipt.email);
    if (receipt.contract_comment) {
      emails = emails.concat(extractEmails(receipt.contract_comment));
    }
    emails = Array.from(new Set(emails));
    setAvailableEmails(emails);

    // 2) phone
    let phones = [];
    const phoneRegex = /((?:8|\+7)[\s-]*(?:\(?\d{3}\)?)[\s-]*\d{3}[\s-]*\d{2}[\s-]*\d{2})/g;
    if (receipt.delivery_comment) {
      const m = receipt.delivery_comment.match(phoneRegex) || [];
      phones = m.map(p => p.replace(/[\s\-()]/g, ""));
    }
    phones = Array.from(new Set(phones));
    setAvailablePhones(phones);

    // 3) предвыбор: email > phone
    if (emails.length > 0) {
      setSelectedContact({ type: 'email', value: emails[0] });
      setEmail(emails[0]);
    } else if (phones.length > 0) {
      setSelectedContact({ type: 'phone', value: phones[0] });
      setPhone(phones[0]);
    }
  }, [receipt]);
      
    
      const extractEmails = (text) => {
        if (!text) return [];
        const emailRegex = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
        return text.match(emailRegex) || [];
      };
    

  const handleIssueCheck = async () => {
    /*if (!selectedContact.value) {
      setError('Выберите телефон или email');
      return;
    }*/
    setIsProcessing(true);
    try {
      const payload = {
        paymentMethod, // "cash" или "card"
        sendOptions: {
          email: email.trim() || receipt.email || null,
          phone: phone.trim() || null,
        },
      };
      console.log('IssueCheck payload:', payload);
      const newCheck = await api.post(`/check/${receiptId}/issue-check`, payload);
      updateReceipt(newCheck);
      goTo('check');
    } catch {
      setError('Ошибка при формировании чека');
    } finally {
      setIsProcessing(false);
    }
  };

  const handleCloseWithoutCheck = async () => {
    setIsProcessing(true);
    try {
      const { data } = await api.patch(`/receipts/${receiptId}/status`, { status: 'Закрыта' });
      updateReceipt(data);
      setReceipt(data);
    } catch {
      setError('Ошибка при закрытии квитанции');
    } finally {
      setIsProcessing(false);
    }
  };

  if (loading)  return <div className={styles.formContainer}><p>Загрузка…</p></div>;
  if (error)    return <div className={styles.formContainer}><p className={styles.error}>{error}</p></div>;
  if (!receipt) return (
  <div className={styles.formContainer}>
    <p>Квитанция с ID {receiptId} не найдена</p>
  </div>
);

  const contactBlob = [
    receipt.delivery_comment,
    receipt.contract_comment,
    receipt.phone_number,
    receipt.email,
  ]
    .filter(Boolean)
    .join(' ');



  // готово, рендерим форму
  return (
    <div className={styles.formContainer}>
      <h3 className={styles.heading}>Настройка чека</h3>

      {/* Payment method */}
      <div className={styles.inputGroup}>
        <label className={styles.label}>Способ оплаты:</label>
        <div className={styles.paymentOptions}>
          {['cash','card'].map(m => (
            <div
              key={m}
              className={`${styles.paymentOption} ${paymentMethod === m ? styles.selected : ''}`}
              onClick={() => setPaymentMethod(m)}
            >
              {m === 'cash' ? 'Наличные' : 'Карта'}
            </div>
          ))}
        </div>
      </div>

      {/* Email */}
      <div className={styles.inputGroup}>
        <label className={styles.label}>Email:</label>
        {isManualEmail ? (
          <div className={styles.contactWrapper}>
            <input
              ref={emailInputRef}
              className={styles.contactOption}
              type="email"
              value={email}
              onChange={e => {
                setEmail(e.target.value);
                handleSelectContact('email', e.target.value);
              }}
              placeholder="Введите email"
            />
            <button
              className={styles.contactOption}
              onClick={cancelManualEmail}
            >Отменить</button>
          </div>
        ) : (
          <div className={styles.contactWrapper}>
            {availableEmails.map((em, i) => (
              <div
                key={i}
                className={`${styles.contactOption} ${
                  selectedContact.type==='email' && selectedContact.value===em ? styles.selected : ''
                }`}
                onClick={() => { setIsManualPhone(false); handleSelectContact('email', em); }}
              >{em}</div>
            ))}
            <button
              className={styles.contactOption}
              onClick={handleManualEmail}
            >Ввести email вручную</button>
          </div>
        )}
      </div>

      {/* Phone */}
      <div className={styles.inputGroup}>
        <label className={styles.label}>Телефон:</label>
        {isManualPhone ? (
          <div className={styles.contactWrapper}>
            <input
              ref={phoneInputRef}
              className={styles.contactOption}
              type="text"
              value={phone}
              onChange={e => {
                setPhone(e.target.value);
                handleSelectContact('phone', e.target.value);
              }}
              placeholder="Введите телефон"
            />
            <button
              className={styles.contactOption}
              onClick={cancelManualPhone}
            >Отменить</button>
          </div>
        ) : (
          <div className={styles.contactWrapper}>
            {availablePhones.map((ph, i) => (
              <div
                key={i}
                className={`${styles.contactOption} ${
                  selectedContact.type==='phone' && selectedContact.value===ph ? styles.selected : ''
                }`}
                onClick={() => { setIsManualEmail(false); handleSelectContact('phone', ph); }}
              >{ph}</div>
            ))}
            <button
              className={styles.contactOption}
              onClick={handleManualPhone}
            >Ввести телефон вручную</button>
          </div>
        )}
      </div>

      {/* Actions */}
      <div className={styles.actionGroup}>
        <button
          className={styles.issueButton}
          disabled={isProcessing}
          onClick={() => {
            // ставим блокировку
            setIsProcessing(true);
            // вызываем то, что нужно
            handleIssueCheck();
            // через 5 секунд разблокируем кнопку
            setTimeout(() => {
              setIsProcessing(false);
            }, 5000);
          }}
        >
          {isProcessing
            ? 'Пожалуйста, подождите…'
            : (receipt.is_check_issued ? 'Посмотреть чек' : 'Пробить чек')}
        </button>
        {/*<button
          className={styles.closeButton}
          onClick={handleCloseWithoutCheck}
          disabled={isProcessing}
        >
          Закрыть без чека
        </button>*/}
      </div>

      {/* Status & summary */}
      <div className={styles.statusLine}>
        <strong>Статус:</strong> {receipt.status}
      </div>
      <div className={styles.summary}>
        <span><i className="bi bi-hash" /> {receipt.id}</span>
        <span><i className="bi bi-person-fill" /> {receipt.client_name}</span>
        <span><i className="bi bi-receipt" /> {receipt.receipt_number}</span>
      </div>
      <div className={styles.productsList}>
        {receipt.products.map(p => (
          <div key={p.id} className={styles.productItem}>
            <strong className={styles.productName}>{p.product_name}</strong>
            <div className={styles.productInfo}>
              <i className="bi bi-droplet" /> {p.actual_quantity}
              <i className="bi bi-cash" /> {p.price} ₽
              {p.gtin==='04600840744001' && (
                <>
                  <i className="bi bi-bucket" />{p.actual_tare_sale_quantity||0}
                  <i className="bi bi-cash-coin" />{p.tare_price||0} ₽
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
